/**
 * List Schema of Auditoria
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Auditoria} from '@/model/resource/Auditoria'

/* TODO: review generated schema */
export class ListAuditoriaSchema extends Schema {
  readonly name = 'ListAuditoria'

  readonly fieldSet: FieldSet<Auditoria> = {
    idAuditoriaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    auditoriaMotivo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.auditoriaMotivo?.$id,
      },
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    conforme: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.conforme),
      },
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    dataCanhoto: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCanhoto),
      },
    }),
  }
}
